import React from 'react'
import styled from 'react-emotion'
import { borderRadius, color, space, z } from '../../style'
import { StyledButton as Button } from '../common/Button'
import Text from 'common/components/Text'
import { StyledFormElement as FormElement } from '../common/FormElement'

export const NotificationList = styled('div')({
  label: 'Notifications',
  position: 'absolute',
  bottom: space.default,
  right: space.default,
  zIndex: z.alert
})
export const Notification = styled('div')({
  label: 'Notification',

  // layout
  marginTop: space.default, // space between notificaitons

  // box
  background: color.black,
  borderRadius,

  // content
  display: 'flex', // needed for alignItems
  alignItems: 'center', // vertically center text
  lineHeight: 1,
  color: 'white',

  [FormElement]: {
    border: 'none',
    color: 'white'
  },

  overflow: 'hidden', // keeps button hover BG inside
  [Button]: {
    borderLeft: '1px solid #3c3c3c',
    borderRadius: 0
  }
})

const Notifications = ({ notifications, dismiss }) => (
  <NotificationList>
    {notifications.map(({ id, message, actions = [] }) => (
      <Notification key={id}>
        <FormElement large>
          <Text>{message}</Text>
        </FormElement>
        <FormElement.Spacer />
        {actions.map(action => (
          <Button
            large
            primary
            onClick={e => action.action(e, { dismiss: () => dismiss(id) })}
            key={action.label}
            className="ignore-react-onclickoutside"
          >
            <Text medium>{action.label}</Text>
          </Button>
        ))}
      </Notification>
    ))}
  </NotificationList>
)

export default Notifications
